import type { AxiosResponse } from "axios";

import { getData } from "@/apis/apiInstance";

import type { ProfitLossPayload } from "@/commonTypes/insightAdvancedTypes";

export async function getInsightApi(data: any): Promise<AxiosResponse> {
  const { type, client_code, token, start_FY, end_FY, branch_id } = data;
  return await getData(`report-module/monthly-ledger-report`, {
    params: {
      client_code,
      type,
      start_FY,
      end_FY,
      ...(branch_id ? { branch_id } : {}),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getProfitLossApi(
  data: ProfitLossPayload
): Promise<AxiosResponse> {
  const { client_code, token, FY, branch_id } = data;

  return await getData(`report-module/monthly-profit-loss-report`, {
    params: {
      client_code,
      FY,
      ...(branch_id ? { branch_id } : {}),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
